"use client";
import { useTranslations } from "next-intl";
import { useCallback } from "react";

export const useStepProgress = ({ pageName, step }) => {
  const t = useTranslations();
  const { CONF, ORDER_DONE, DOMAIN_OPT, ACC_DETAILS, CONF_VPS, ORDER_PER } = {
    CONF: t("configuration"),
    ORDER_DONE: t("completedOrder"),
    DOMAIN_OPT: t("domainOptions"),
    CONF_VPS: t("configVps"),
    ACC_DETAILS: t("accountDetails"),
    ORDER_PER: t("orderPeriod"),
  };

  const TITLES = {
    vps_hosting_title: {
      stepsSubtitles: { step_one: CONF_VPS, step_two: ACC_DETAILS },
      stepsTitles: [CONF_VPS, ORDER_DONE],
      stepNav: ["/vps-hosting/purchase", "/vps-hosting/purchase"],
    },
    domain: {
      stepsSubtitles: {
        step_one: DOMAIN_OPT,
        step_two: DOMAIN_OPT,
        step_three: ORDER_DONE,
      },
      stepsTitles: [ORDER_PER, t("domainConf"), ORDER_DONE],
      stepNav: [
        "/domain/purchase",
        "/domain/purchase/configuration",
        "/domain/purchase/configuration",
      ],
    },
    web_hosting: {
      stepsSubtitles: {
        step_one: t("hostingConf"),
        step_two: ORDER_DONE,
      },
      stepsTitles: [CONF, ORDER_DONE],
      stepNav: ["/web-hosting/purchase", "/web-hosting/purchase"],
    },
    d_server: {
      stepsSubtitles: {
        step_one: t("serverConf"),
        step_two: ORDER_DONE,
      },
      stepsTitles: [CONF, ORDER_DONE],
      stepNav: ["/dedicated-server/purchase", "/dedicated-server/purchase"],
    },
  };
  const { stepsTitles, stepNav } = TITLES[pageName];
  const stepsHandler = useCallback(() => {
    const steps = {
      step_one: {
        defTitle: t("almostThere"),
        items: {
          colors: ["bg-mainLightPurple", "bg-slate-200", "bg-slate-200"],
          titles: stepsTitles?.slice(0, 1),
        },
      },
      step_two: {
        defTitle: t("veryFew"),
        items: {
          colors: ["bg-green-400", "bg-mainLightPurple", "bg-slate-200"],
          titles: stepsTitles?.slice(0, 2),
        },
      },
      step_three: {
        defTitle: "The last step!",
        items: {
          colors: ["bg-green-400", "bg-green-400", "bg-mainLightPurple"],
          titles: stepsTitles?.slice(0, 3),
        },
      },
    };
    return steps[step];
  }, [stepsTitles, step]);

  const {
    items: { colors, titles },
    defTitle,
  } = stepsHandler();
  return {
    colors,
    titles,
    defTitle,
    stepNav,
    stepTitle: stepsTitles[step],
  };
};
